document.addEventListener('DOMContentLoaded', function() {
  const childMenuToggles = document.querySelectorAll('.child-menu-toggle');
  
  childMenuToggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      const parentLi = this.closest('li');
      const submenu = parentLi.querySelector('.header-list-unstyled');
      
      // Close all other open menus at the same level
      const siblings = parentLi.parentElement.children;
      Array.from(siblings).forEach(sibling => {
        if (sibling !== parentLi) {
          const siblingSubmenu = sibling.querySelector('.header-list-unstyled');
          if (siblingSubmenu) {
            siblingSubmenu.classList.remove('show');
          }
        }
      });
      
      // Toggle the clicked menu
      submenu.classList.toggle('show');
    });
  });
}); 